<template>
  <div>
    <header class="main-header">
      <div class="d-flex h-110">
        <div class="logo">
          <router-link :to="{ name: assignmentsPage }">
            <img src="@/assets/img/logo.svg" alt="Logo" />
          </router-link>
        </div>
        <div class="header-title align-self-center">
          <router-link :to="{ name: assignmentsPage }">
            <Logo21Grams />
            <span class="header-title-page">{{ page }}</span>
          </router-link>
        </div>

        <div class="header-action">
          <b-button v-if="!isStaff" class="btn btn-help" href="mailto:support@21grams.com"> Need help? </b-button>

          <!-- App dropdown -->
          <button class="menu-button" :class="{ open: dropMenuShow }" @click="toggleDropMenu">
            <span class="icon-mask"></span>
          </button>

          <!-- Menu dropdown -->
          <div v-if="dropMenuShow" v-click-outside="hideDropMenu" class="menu-dropdown">
            <router-link v-if="can('manage', 'prices')" :to="{ name: basePricePage }"> Base Prices </router-link>
            <router-link v-if="can('view', 'reports')" :to="{ name: reportsPage }"> Reports </router-link>
            <router-link v-if="can('view', 'inventory')" :to="{ name: inventoryPage }"> Inventory Management </router-link>
            <router-link v-if="isStaff" :to="{ name: addressBookPage }"> Address Book</router-link>
            <router-link v-if="can('manage', 'staff.area')" :to="{ name: staffUsersPage }"> Staff users </router-link>
            <router-link v-if="can('view', 'auditLogs')" :to="{ name: auditLogsPage }"> Activity Logs </router-link>

            <a href="#" @click="logout">
              <span>Sign out</span>
              <span class="logout-icon"></span>
            </a>

            <a href="tel: +4686003721">
              <span>Support <b>+46 8 600 37 21</b></span>
              <span class="phone-icon"></span>
            </a>
          </div>
        </div>
      </div>
    </header>
    <div class="pattern" />
  </div>
</template>

<script lang="ts">
import { BButton } from 'bootstrap-vue-next'
import { ref, computed, watch, defineComponent } from 'vue'
import { useRoute } from 'vue-router'
import { useAccountStore } from '@/store/account'
import { useAuthStore } from '@/store/auth'
import {
  CUSTOMER_ASSIGNMENTS_LIST,
  STAFF_ASSIGNMENTS_LIST,
  STAFF_BASE_PRICE_PAGE,
  STAFF_INVENTORY,
  STAFF_REPORTS,
  STAFF_USERS_LIST,
  STAFF_ADDRESS_BOOK,
  STAFF_AUDIT_LOGS,
} from '@/types/router'
import Logo21Grams from '@/views/Components/Elements/Icons/Logo21Grams.vue'

export default defineComponent({
  name: 'LayoutHeader',
  components: { BButton, Logo21Grams },
  setup() {
    const route = useRoute()
    const authStore = useAuthStore()
    const accountStore = useAccountStore()

    const dropMenuShow = ref(false)

    const ability = computed(() => accountStore.ability)
    const isStaff = computed(() => accountStore.isStaff)
    const assignmentsPage = computed(() => (isStaff.value ? STAFF_ASSIGNMENTS_LIST : CUSTOMER_ASSIGNMENTS_LIST))
    const page = computed(() => (route.meta.title ? `/ ${route.meta.title}` : ''))
    const basePricePage = STAFF_BASE_PRICE_PAGE
    const inventoryPage = STAFF_INVENTORY
    const addressBookPage = STAFF_ADDRESS_BOOK
    const reportsPage = computed(() => (isStaff.value ? STAFF_REPORTS : CUSTOMER_ASSIGNMENTS_LIST))
    const staffUsersPage = STAFF_USERS_LIST
    const auditLogsPage = STAFF_AUDIT_LOGS

    const logout = () => {
      authStore.logout()
    }

    const hideDropMenu = () => {
      dropMenuShow.value = false
    }

    const toggleDropMenu = () => {
      dropMenuShow.value = !dropMenuShow.value
    }

    watch(route, () => {
      dropMenuShow.value = false
    })

    const can = (rule: string, section: string) => ability.value.can(rule as any, section as any)

    return {
      page,
      isStaff,
      reportsPage,
      dropMenuShow,
      basePricePage,
      inventoryPage,
      addressBookPage,
      staffUsersPage,
      auditLogsPage,
      assignmentsPage,
      toggleDropMenu,
      hideDropMenu,
      logout,
      can,
    }
  },
})
</script>
